__turbopack_context__.v({
  "buttons-container": "linkingsList-module-scss-module__GVjlxq__buttons-container",
  "contact": "linkingsList-module-scss-module__GVjlxq__contact",
  "fade-in-unwkqqa": "linkingsList-module-scss-module__GVjlxq__fade-in-unwkqqa",
  "linking-list": "linkingsList-module-scss-module__GVjlxq__linking-list",
  "linking-list-header": "linkingsList-module-scss-module__GVjlxq__linking-list-header",
  "wrapper": "linkingsList-module-scss-module__GVjlxq__wrapper",
});
